import React, { useContext, useEffect, useRef, useState } from "react";
import "./GlobalSettings.css";
import SelectList from "../../components/SelectList/SelectList.js";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faBook,
  faBuilding,
  faFileUpload,
  faUpload,
  faVoteYea,
} from "@fortawesome/free-solid-svg-icons";

//Context
import authContext from "../../context/authentication/authContex";
import subCuentasContext from "../../context/subcuentas/subcuentasContext.js";

//Api
import { getAllGroup } from "../../api/group.js";

const GlobalSettings = () => {
  const { globalSettings, obtenerGlobalSettings, updateGlobalSettings } =
    useContext(authContext);

  const [loading, setLoading] = useState(true);
  const [updated, setUpdated] = useState(null);
  const [sideNavBarHovered, setSideNavBarHovered] = useState(false);
  const [hoveringImgContainer, setHoveringImgContainer] = useState(false);
  const [companyImg, setCompanyImg] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const [saving, setSaving] = useState(false);
  const [grupos, setGrupos] = useState([]);

  const preferencesSectionRef = useRef(null);
  const companySectionRef = useRef(null);
  const fileInputRef = useRef(null);
  const actionOverImg = useRef("");

  const subCueContext = useContext(subCuentasContext);
  const { dimensiones, actualizarDimensiones } = subCueContext;

  useEffect(() => {
    const fn = async () => {
      try {
        await actualizarDimensiones();
        await obtenerGlobalSettings();
        const respGrupos = await getAllGroup();
        if (respGrupos.data?.data) {
          setGrupos(respGrupos.data.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fn();
  }, []);

  useEffect(() => {
    if (!globalSettings) return;
    setPreviewURL(globalSettings.companyImgURL || null);

    // Buscar el nombre del grupo si existe defaultGroupTDoc
    let grupoNombre = "";
    if (globalSettings.defaultGroupTDoc && grupos.length > 0) {
      const grupoEncontrado = grupos.find(
        (g) => g._id === globalSettings.defaultGroupTDoc
      );
      if (grupoEncontrado) {
        grupoNombre = grupoEncontrado.name;
      }
    }
    setUpdated({ ...globalSettings, grupoNombre });
  }, [globalSettings, grupos]);

  useEffect(() => {
    return () => {
      if (previewURL?.startsWith("blob:")) {
        URL.revokeObjectURL(previewURL);
      }
    };
  }, [previewURL]);

  const handleChangeGlobalSettings = (e) => {
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setUpdated((prevUpd) => {
      let updatedValues = {
        ...prevUpd,
        [name]: newValue,
      };

      if (name === "requiredSubcuenta" && newValue === false) {
        updatedValues.codDim = "";
        updatedValues.codDimDescrp = "";
      }

      return updatedValues;
    });
  };

  const handleChangeDimension = async (value) => {
    const dimensionSeleccionada = dimensiones.find(
      (s) =>
        `${s.codDim}`.replace(/\s+/g, "") === value.value.replace(/\s+/g, "")
    );

    if (dimensionSeleccionada !== undefined) {
      setUpdated((prevUpd) => ({
        ...prevUpd,
        codDim: dimensionSeleccionada.codDim,
        codDimDescrp: dimensionSeleccionada.codDimDescrp,
      }));
    }
  };

  const handleChangeGrupo = async (value) => {
    const grupoSeleccionado = grupos.find(
      (g) => `${g._id}`.replace(/\s+/g, "") === value.value.replace(/\s+/g, "")
    );

    if (grupoSeleccionado !== undefined) {
      setUpdated((prevUpd) => ({
        ...prevUpd,
        defaultGroupTDoc: grupoSeleccionado._id,
        grupoNombre: grupoSeleccionado.name,
      }));
    }
  };

  const handleScroll = (scrollingTo) => {
    switch (scrollingTo) {
      case "preferences":
        preferencesSectionRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "company":
        companySectionRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
    }
  };

  const handleSearchImgCompany = () => {
    fileInputRef.current?.click();
  };
  const handleDragOverImgContainer = (e) => {
    e.preventDefault();
    setHoveringImgContainer(true);
  };
  const handleDragLeaveImgContainer = (e) => {
    e.preventDefault();
    setHoveringImgContainer(false);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    actionOverImg.current = "CHANGED";
    if (file) {
      // Detectar extensión del archivo
      const fileType = file.type; // image/jpeg o image/png etc.
      const originalName = file.name;
      let newFile = file;
      if (fileType === "image/jpeg") {
        if (originalName.toLowerCase().endsWith(".jpeg")) {
          const newName = originalName.replace(/\.jpeg$/i, ".jpg");

          // Crear un nuevo archivo con el nuevo nombre manteniendo el contenido
          newFile = new File([file], newName, { type: file.type });
        }

        setCompanyImg(newFile);
        const objectURL = URL.createObjectURL(newFile);
        setPreviewURL(objectURL);
      } else
        Swal.fire({
          title: "Ops!",
          text: "Solo se permiten imagenes en formato .jpg",
          icon: "error",
        });
    }
  };
  const handleDropFile = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    actionOverImg.current = "CHANGED";
    if (file) {
      const fileType = file.type;
      const originalName = file.name;
      let newFile = file;
      if (fileType === "image/jpeg") {
        if (originalName.toLowerCase().endsWith(".jpeg")) {
          const newName = originalName.replace(/\.jpeg$/i, ".jpg");
          newFile = new File([file], newName, { type: file.type });
        }

        setCompanyImg(newFile);
        const objectURL = URL.createObjectURL(newFile);
        setPreviewURL(objectURL);
      } else
        Swal.fire({
          title: "Ops!",
          text: "Solo se permiten imagenes en formato .jpg",
          icon: "error",
        });
    }
  };

  const handleDeleteFile = (e) => {
    e.preventDefault();
    //Solo si ya tenia una cargada seteo que debe ser Eliminada del S3.
    if (globalSettings.companyImgURL) actionOverImg.current = "DELETED";
    else actionOverImg.current = "";
    setPreviewURL(null);
    setCompanyImg(null);
  };

  const handleSave = async () => {
    setSaving(true);
    const updatedCopy = { ...updated };
    if (updated.requiredSubcuenta == true && updated.codDim == "") {
      Swal.fire({
        title: "Seleccione una dimensión",
        text: "Debe seleccionar una dimensión",
        icon: "warning",
      });
      setSaving(false);
      return;
    } else if (updatedCopy.requiredSubcuenta === false) {
      updatedCopy.codDim = "";
    }
    Swal.fire({
      title: "Aguarde a que se apliquen los cambios...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      let res = await updateGlobalSettings(
        { ...updatedCopy, previewURL },
        companyImg,
        actionOverImg.current
      );
      if (res) {
        setSaving(false);
        actionOverImg.current = "";
        Swal.fire({
          title: "Configuración global actualizada exitosamente!",
          icon: "success",
        });
      } else {
        setSaving(false);
        Swal.fire({
          title: "Error al actualizar la configuración",
          text: "La operación no fue exitosa.",
          icon: "error",
        });
      }
    } catch (error) {
      setSaving(false);
      console.error("Error al guardar configuración:", error);
      Swal.fire({
        title: "Error inesperado",
        text: "Ocurrió un error al intentar guardar la configuración.",
        icon: "error",
      });
    }
  };

  if (loading) {
    return (
      <div
        className="container-gr-addreq"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="globalSettingsView">
        <div
          className="sideNavigationBar"
          onMouseEnter={() => setSideNavBarHovered(true)}
          onMouseLeave={() => setSideNavBarHovered(false)}
        >
          {!sideNavBarHovered && (
            <FontAwesomeIcon icon={faBars} className="icon" />
          )}
          <div className="sideNavBarContent">
            <h4 onClick={() => handleScroll("preferences")}>
              Preferencias <FontAwesomeIcon icon={faVoteYea} />
            </h4>
            <h4 onClick={() => handleScroll("company")}>
              Compañia <FontAwesomeIcon icon={faBuilding} />
            </h4>
          </div>
        </div>

        <div
          className="globalSettingsChildContainer"
          ref={preferencesSectionRef}
        >
          <h3>Preferencias</h3>
          <div className="openNewTabSetup">
            {updated && (
              <>
                <div className="inputGroup">
                  <div
                    style={{
                      width: "95%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <h5>Solicita subcuenta al cargar comprobantes:</h5>
                    </div>
                    <div className="inputRequiredSubcuenta">
                      <input
                        name="requiredSubcuenta"
                        onChange={(e) => handleChangeGlobalSettings(e)}
                        checked={updated.requiredSubcuenta}
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>

                {updated?.requiredSubcuenta && (
                  <div className="selectDimension">
                    <SelectList
                      text={"Dimensión"}
                      options={dimensiones.map((d) => {
                        return {
                          value: `${d.codDim}`,
                          label: `${d.codDim} - ${d.codDimDescrp}`,
                        };
                      })}
                      handleChange={handleChangeDimension}
                      property={"Dimension"}
                      valueAux={{
                        label: updated.codDim
                          ? `${updated.codDim} - ${updated.codDimDescrp}`
                          : "Seleccione...",
                        value: updated.codDim || "",
                      }}
                      emptyInputs={[]}
                      styles={{
                        additionalStyleDivSelectList: {
                          alignItems: "left",
                        },
                        fontStyleTitle: {
                          fontWeight: "bold",
                          fontSize: "22px",
                          color: "#7c7b7b",
                          marginLeft: "9px",
                        },
                      }}
                      fontBold={true}
                    />
                  </div>
                )}

                <div className="inputGroup">
                  <div
                    style={{
                      width: "95%",
                      display: "flex",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                  >
                    <div>
                      <h5>Envía mail de notificación de pago a proveedores:</h5>
                    </div>
                    <div className="inputRequiredSubcuenta">
                      <input
                        name="envioMailPagoProvs"
                        onChange={(e) => handleChangeGlobalSettings(e)}
                        checked={updated.envioMailPagoProvs}
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="companyInfo" ref={companySectionRef}>
            <h3>Compañía</h3>
            {updated && (
              <div className="inputGroup">
                <div
                  style={{
                    width: "95%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h5>Nombre de la Empresa:</h5>
                  </div>
                  <div className="inputRequiredSubcuenta">
                    <input
                      className="companyNameInput"
                      name="companyName"
                      onChange={(e) => handleChangeGlobalSettings(e)}
                      value={updated.companyName || ""}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="logoCompanyRow">
              <h5 className="logoCompanyLabel">Logo de la Empresa:</h5>
              {previewURL ? (
                <div className="previewCompanyImgContainer">
                  <img
                    className="previewCompanyImg"
                    src={previewURL}
                    alt={`${updated.companyName}-imgPreview`}
                  />
                  <button
                    className="buttonEliminarImagen"
                    onClick={handleDeleteFile}
                  >
                    Eliminar Imagen
                  </button>
                </div>
              ) : (
                <div className="uploadPhotoContainer">
                  <div
                    className="dropPhotoContainer"
                    style={
                      hoveringImgContainer ? { borderColor: "orange" } : {}
                    }
                    onClick={handleSearchImgCompany}
                    onDrop={(e) => handleDropFile(e)}
                    onDragOver={handleDragOverImgContainer}
                    onDragLeave={handleDragLeaveImgContainer}
                  >
                    <label>
                      Suelte una imagen aqui o presione para buscarla en sus
                      archivos <FontAwesomeIcon icon={faFileUpload} />
                    </label>
                  </div>
                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </div>
              )}
            </div>

            <SelectList
              text={
                "Grupo por defecto para asignación de comprobantes Proveedores:"
              }
              options={grupos.map((g) => {
                return {
                  value: `${g._id}`,
                  label: `${g.name}`,
                };
              })}
              handleChange={handleChangeGrupo}
              property={"Grupo"}
              valueAux={{
                label: updated?.grupoNombre
                  ? `${updated.grupoNombre}`
                  : "Seleccione...",
                value: updated?.defaultGroupTDoc || "",
              }}
              emptyInputs={[]}
              maxHeightMenu="20vh"
              styles={{
                additionalStyleDivSelectList: {
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: "12px",
                  gap: "15px",
                },
                fontStyleTitle: {
                  fontSize: "1.25rem",
                  fontWeight: "500",
                  letterSpacing: "2px",
                  marginLeft: "0.4rem",
                  width: "50%",
                  flexShrink: 0,
                },
              }}
              fontBold={true}
            />
          </div>
        </div>
        <button disabled={saving} onClick={handleSave} className="saveBtn">
          guardar
        </button>
      </div>
    );
  }
};

export default GlobalSettings;